var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.admin ? _c("admin-sidebar-menu") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper" }, [
            _c("div", { staticClass: "container-wrapper center" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "heading-seperator" }),
              _vm._v(" "),
              _c("div", { staticClass: "margin-bottom-10" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mentor-container primaryadmin-dashboard" },
                [
                  _c("flash-message", {
                    attrs: { autoHide: "", variant: "success" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "list-users" },
                    [
                      _c(
                        "table-component",
                        {
                          ref: "table7",
                          attrs: {
                            data: _vm.groups,
                            "show-caption": false,
                            "show-filter": false,
                            "cache-key": 7,
                            "cache-lifetime": "0",
                            "filter-no-results": _vm.no_result
                          }
                        },
                        [
                          _c("table-column", {
                            attrs: {
                              show: "groupName",
                              sortable: true,
                              label: "GROUP NAME"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: { to: "/group-users/" + row.id }
                                      },
                                      [_vm._v(_vm._s(row.groupName))]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("table-column", {
                            attrs: {
                              show: "parentGroupName",
                              sortable: false,
                              label: "PARENT GROUP"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(row) {
                                  return [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(row.parentGroupName) +
                                        "\n                  "
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("table-column", {
                            attrs: { sortable: false },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-red btn-md input-height-15",
                                        on: {
                                          click: function($event) {
                                            return _vm.goToEdit(row.id)
                                          }
                                        }
                                      },
                                      [_vm._v("Edit")]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "d-inline heading" }, [_vm._v("Home")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30282468", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30282468","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/primaryadmin/primadmin_dashboard.vue
// module id = null
// module chunks = 